<section class="contact-hero-section">
    <div class="contact-hero-container">
        <div class="contact-two-column-wrapper">

            <div class="contact-form-block">
                
                <ng-container *ngIf="!isSubmitted">
                    <h2 class="form-block-title">Get in touch</h2>
                    <p class="form-block-subtitle">We're open for any suggestion or just to have a chat.</p>

                    <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form-hero">
                        <div class="row">
                            <div class="col-12 mb-3">
                                <input type="text" class="form-control" name="name" id="name"
                                    placeholder="Your name" formControlName="name">
                            </div>
                            <div class="col-12 mb-3">
                                <input type="email" class="form-control" name="email"
                                    placeholder="Your mail" formControlName="email">
                            </div>
                            <div class="col-12 mb-3" *ngIf="!showContactInfo">
                                <input type="tel" class="form-control" name="mobile" id="mobile"
                                    placeholder="Your phone" formControlName="mobile">
                            </div>
                            <div class="col-12 mb-3" *ngIf="showContactInfo">
                                <input type="text" class="form-control" name="subject" id="subject"
                                    placeholder="Subject" formControlName="subject">
                            </div>
                            <div class="col-12 mb-3">
                                <textarea name="message" class="form-control" id="message" cols="30" rows="4"
                                    placeholder="Your message" formControlName="message"></textarea>
                            </div>
                            <div class="col-12">
                                <button type="button" class="submit-message-button" (click)="submitForm()">
                                    Send Message
                                </button>
                                <div class="submitting"></div>
                            </div>
                        </div>
                    </form>
                </ng-container>

                <ng-container *ngIf="isSubmitted">
                    <div class="alert alert-success mt-3">
                        Stay tuned, we'll be reaching out to you shortly.
                    </div>
                </ng-container>
                
            </div>

            <div class="contact-info-block new-style-info-block" *ngIf="!isSubmitted">
                <h2 class="info-block-title">Contact us details</h2>
               
                
                <div class="contact-detail-list">
                    <div class="contact-detail-item">
                        <i class="fas fa-map-marker-alt"></i>
                        <div class="text">
                            <p><span>Address:</span> Direkt FZCO, Building A1, Dubai Digital Park, Silicon Oasis, Dubai, UAE.</p>
                        </div>
                    </div>
                    
                    <div class="contact-detail-item">
                         <i class="fas fa-envelope"></i>
                        <div class="text">
                            <p><span>Email:</span> customercare@direkt.ae</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

